import { gql, TypedDocumentNode } from '@apollo/client';

import type {
  SearchUsersByUserNameQuery,
  SearchUsersByUserNameQueryVariables,
} from '#graphql/generated';

export const SEARCH_USERS_BY_USER_NAME: TypedDocumentNode<
  SearchUsersByUserNameQuery,
  SearchUsersByUserNameQueryVariables
> = gql`
  query SearchUsersByUserName($query: String!) {
    searchUsersByUserName(query: $query) {
      id
      userName
      displayName
    }
  }
`;
